import { PercentCrop } from '../../../Models/Geometry/Crop/PercentCrop';
import { TextProcessingData } from './TextProcessingData';
import { TextProcessingFrame } from './TextProcessingFrame';

export class SmoStoryMoonTextProcessingData implements TextProcessingData {
  public titleFrame(brightness: number): TextProcessingFrame {
    return {
      crop: new PercentCrop(4, 5, 92, 25),
      rotation: 0,
      filters: [
        { name: 'saturation', value: -1 },
        { name: 'brightness', value: brightness },
        { name: 'contrast', value: 12 },
        { name: 'negative', value: 1 },
        { name: 'brightness', value: brightness },
        { name: 'contrast', value: 100 },
        { name: 'brightness', value: 1 },
        { name: 'contrast', value: 100 }
      ]
    };
  }

  public nameFrame(brightness: number): TextProcessingFrame {
    return {
      crop: new PercentCrop(5, 82, 85, 10),
      rotation: 4,
      filters: [
        { name: 'saturation', value: -1 },
        { name: 'brightness', value: brightness },
        { name: 'contrast', value: 12 },
        { name: 'negative', value: 1 },
        { name: 'brightness', value: brightness },
        { name: 'contrast', value: 100 },
        { name: 'brightness', value: 1 },
        { name: 'contrast', value: 100 }
      ]
    };
  }
}
